import { render, staticRenderFns } from "./PdfarlIndextab5.vue?vue&type=template&id=5557ae3a"
import script from "./PdfarlIndextab5.vue?vue&type=script&lang=js"
export * from "./PdfarlIndextab5.vue?vue&type=script&lang=js"
import style0 from "./PdfarlIndextab5.vue?vue&type=style&index=0&id=5557ae3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports